import { createEvent, sample } from 'effector'

import { $$auth } from '@shared/auth'
import { postpone } from '@shared/lib/effector/postpone'

import { isAuthenticatedQuery } from '../api/isAuthenticatedQuery'

export const setup = createEvent<void>()

const $hasToken = $$auth.token.$access.map((token) => token !== null)

sample({
  clock: postpone({ clock: setup, until: $hasToken }),
  target: isAuthenticatedQuery.start,
})

sample({
  clock: isAuthenticatedQuery.finished.success,
  filter: ({ data }) => Boolean(data.user?.id),
  fn: () => true,
  target: $$auth.status.$authed,
})

sample({
  clock: isAuthenticatedQuery.finished.finally,
  fn: () => true,
  target: $$auth.status.$checked,
})
